<template>

  <div class="container">

    <div class="row">
      <div class="col-12 d-flex flex-row justify-content-between">
        <div>
          <h2>{{ employeeSectionHeading }}</h2>
        </div>
      </div>

      <div class="w-100"></div>

      <your-profile-your-details-component
        :scheme="scheme"
        :product="product"
        :profile="profile"
        :mileagePercent="mileagePercent"
        :tooltip="tooltip"
        :taxBandTooltip="taxBandTooltip"
        :adminPortalData="adminPortalData"
      />

      <template v-if="showScheme">
        <div class="w-100 spacer"></div>

        <div class="col-8 d-flex flex-row justify-content-between">
          <div>
            <h2>{{ schemeSectionHeading }}</h2>
            <p v-if="schemeDescription">{{ schemeDescription }}</p>
          </div>
        </div>

        <div class="w-100"></div>

        <your-profile-scheme-details-component
          :product="product"
          :profile="profile"
          :scheme="scheme"
          :companyCarScheme="companyCarScheme"
          :essentialBusinessScheme="essentialBusinessScheme"
          :tooltip="tooltip"
          :adminPortalData="adminPortalData"
        />
      </template>
    </div>

  </div>
</template>

<script>
import YourProfileYourDetailsComponent from "./your-profile-your-details-component";
import YourProfileSchemeDetailsComponent from "./your-profile-scheme-details-component";
import {useRoute} from 'vue-router'

export default {
  name: 'your-profile-form-component',
  components: {YourProfileSchemeDetailsComponent, YourProfileYourDetailsComponent},
  props: [
    'profile',
    'session',
    'adminPortalData',
    'product',
    'contactTheTeam',
    'employeeSectionHeading',
    'scheme',
    'schemeDescription',
    'schemeSectionHeading',
    'taxBandTooltip',
    'driverGrade',
  ],

  data() {
    return {
      tooltip: true,
    };
  },

  setup() {
    const route = useRoute()
    return { route }
  },

  watch: {
    profile: {
      handler() {
      },
      deep: true
    }
  },

  computed: {
    mileagePercent() {
      const total = Number(this.profile.businessAnnualMileage) + Number(this.profile.privateAnnualMileage);
      return Math.round((Number(this.profile.businessAnnualMileage) / total) * 100);
    },

    companyCarMileageReimbursementRate() {
      if (!this.session.driverProfile) {
        return '';
      }
      return this.session.driverProfile.BCH.driverGradeDefinition.businessFuelPolicyName;
    },

    privateCarMileageReimbursementRate() {
      if (!this.session.driverProfile) {
        return '';
      }
      return this.session.driverProfile.PCH.driverGradeDefinition.businessFuelPolicyName;
    },

    privateCarMileageReimbursementRateUpTo() {
      if (!this.session.driverProfile) {
        return '';
      }
      let fuelRate = '';
      this.session.driverProfile.PCH.driverGradeDefinition.businessFuelRates[0].items.forEach((item) => {
        if (Number(item.upToDistance) <= 10000) {
          fuelRate = (item.fuelRate * 100) + ' ppm';
        }
      });

      return fuelRate;
    },

    privateCarMileageReimbursementRateOver() {
      let maxDistance = 0;
      let maxFuelRate = '';

      if (!this.session.driverProfile) {
        return '';
      }

      this.session.driverProfile.PCH.driverGradeDefinition.businessFuelRates[0].items.forEach((item) => {
        if (Number(item.upToDistance) > 10000 && Number(item.upToDistance) > maxDistance) {
          maxDistance = item.upToDistance;
          maxFuelRate = (item.fuelRate * 100) + ' ppm';
        }
      });
      return maxFuelRate;
    },

    schemeId() {
      return this.route.params.scheme ?? false;
    },

    essentialBusinessScheme() {
      // TODO: Base this upon some kind of API/Env driven logic
      return {
        grade: this.profile.privateCarGrade,
        fuelReimbursement: false,
        netCash: false,
        total: false
      }
    },

    companyCarScheme() {
      // TODO: Base this upon some kind of API/Env driven logic
      // return {
      //     grade: this.profile.companyCarGrade,
      //     fuelReimbursement: false,
      //     netCash: false,
      //     total: Number(this.profile.privateCarCashAllowance).toFixed(2)
      // }
      return false
    },

    contactTheTeamLabel() {
      return this.route.params.scheme === 'ecoamaps' ? 'Query my details' : 'Contact the team';
    },

    showScheme() {
      return this.adminPortalData?.content?.products?.[this.schemeId]?.[0]?.display_settings_show_scheme_details ?? true;
    }
  }

}
</script>
